import { writable } from "svelte/store";

export const otherUsersStore = writable([]);
export const myUserStore = writable();
export const usersStore = writable([]);
